import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const DataUsageIcon = ({ width, height, disabled }: IconProps) => {
  return (
    <BaseIcon
      width={width}
      height={height}
      disabled={disabled}
      viewBox="0 0 15 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 15.5C6.4625 15.5 5.4875 15.3026 4.575 14.9079C3.6625 14.5132 2.86875 13.9774 2.19375 13.3008C1.51875 12.6241 0.984375 11.8283 0.590625 10.9135C0.196875 9.99875 0 9.0213 0 7.9812C0 6.03885 0.64375 4.35338 1.93125 2.92481C3.21875 1.49624 4.825 0.68797 6.75 0.5V2.75564C5.45 2.93108 4.375 3.51378 3.525 4.50376C2.675 5.49373 2.25 6.65288 2.25 7.9812C2.25 9.44737 2.75937 10.6911 3.77812 11.7124C4.79687 12.7337 6.0375 13.2444 7.5 13.2444C8.3 13.2444 9.05937 13.0752 9.77812 12.7368C10.4969 12.3985 11.1125 11.916 11.625 11.2895L13.575 12.4173C12.8625 13.3947 11.975 14.1529 10.9125 14.6917C9.85 15.2306 8.7125 15.5 7.5 15.5ZM14.3625 11.0263L12.4125 9.8985C12.525 9.58521 12.6094 9.2688 12.6656 8.94925C12.7219 8.6297 12.75 8.30702 12.75 7.9812C12.75 6.65288 12.325 5.49373 11.475 4.50376C10.625 3.51378 9.55 2.93108 8.25 2.75564V0.5C10.175 0.68797 11.7812 1.49624 13.0688 2.92481C14.3562 4.35338 15 6.03885 15 7.9812C15 8.50752 14.9531 9.02757 14.8594 9.54135C14.7656 10.0551 14.6 10.5501 14.3625 11.0263Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default DataUsageIcon;
